export const newRelicConfig = {
  info: {
    applicationID: import.meta.env.VITE_NR_ONBOARDING_UI_APPLICATIONID,
    licenseKey: import.meta.env.VITE_NR_ONBOARDING_UI_LICENSEKEY,
    applicationName: 'OnboardingSite',
    sa: true,
  },
  loader_config: {
    accountID: import.meta.env.VITE_NR_ONBOARDING_UI_ACCOUNTID,
    agentID: import.meta.env.VITE_NR_ONBOARDING_UI_AGENTID,
    trustKey: import.meta.env.VITE_NR_ONBOARDING_UI_TRUSTKEY,
    licenseKey: import.meta.env.VITE_NR_ONBOARDING_UI_LICENSEKEY,
    applicationID: import.meta.env.VITE_NR_ONBOARDING_UI_APPLICATIONID
  },
  init: {
    distributed_tracing: {
      enabled: true,
    },
    privacy: {
      cookies_enabled: true,
    },
    ajax: {
      deny_list: [],
      enabled: true,
      harvestTimeSeconds: 10,
    },
    session: {
      domain: undefined,
      expiresMs: 1800000,
      inactiveMs: 1800000,
    },
    page_view_event: {
      enabled: true,
    },
    page_view_timing: {
      enabled: true,
      long_task: true,
    },
    session_trace: {
      enabled: import.meta.env.VITE_NR_SESSION_TRACE_ENABLED === 'true',
      harvestTimeSeconds: 10,
    },
    spa: {
      enabled: true,
      harvestTimeSeconds: 10,
    },
    jserrors: {
      enabled: true,
      harvestTimeSeconds: 10,
    },
  },
};
